export default __webpack_public_path__ + "static/media/BlissPro-Regular.07b25e0f.eot";